import { isPlatformBrowser } from '@angular/common';
import { Component, OnInit, OnDestroy, Inject, AfterContentChecked, PLATFORM_ID } from '@angular/core';
import { HomeService } from '../home.service';
declare var $: any;
@Component({
  selector: 'app-our-clients',
  templateUrl: './our-clients.component.html',
  styleUrls: ['./our-clients.component.css']
})
export class OurClientsComponent implements OnInit, AfterContentChecked, OnDestroy {
  clients: any;

  constructor(
    @Inject(HomeService) private homeService: HomeService,
    @Inject(PLATFORM_ID) private platformId: Object) { }

  ngOnInit() {

    // this.homeService.clientsObservable$.subscribe((data: any) => {
    // this.clients = data;
    //console.log(this.clients);
    this.clients = [{
      'id': 4544,
      'title': "Thornton Tomasetti",
      'feature_image': "assets/images/client/OurClients1.png",
    }, {
      'id': 4541,
      'title': "TVS Credit",
      'feature_image': "assets/images/client/OurClients2.png"
    }, {
      'id': 4535,
      'title': "Recruit",
      'feature_image': "assets/images/client/OurClients.png"
    }, {
      'id': 92,
      'title': "Stockteamup",
      'feature_image': "assets/images/client/stockteamup.png"
    }, {
      'id': 89,
      'title': "Perfit",
      'feature_image': "assets/images/client/perfit-1-1.jpg"
    }, {
      'id': 86,
      'title': "Dear cows",
      'feature_image': "assets/images/client/dearcows.png"
    }, {
      'id': 83,
      'title': "Bubble",
      'feature_image': "assets/images/client/bubble_logo.png"
    }];
    // });
  }

  ngAfterContentChecked() {
    if (isPlatformBrowser(this.platformId)) {
      this.createSlick();
    }
    // $(window).on('resize', this.createSlick);
  }

  createSlick() {
    $(".customer-logos").not('.slick-initialized').slick({
      autoplay: true,
      arrows: false,
      slidesToShow: 4,
      slidesToScroll: 1,
      autoplaySpeed: 1500,
      pauseOnHover: false,
      responsive: [
        {
          breakpoint: 1200,
          settings: {
            slidesToShow: 4
          }
        },
        {
          breakpoint: 992,
          settings: {
            slidesToShow: 3
          }
        },
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 2
          }
        }
      ]
    });
  }

  ngOnDestroy() {
    // $('.customer-logos').slick('unslick');
  }
}
